var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRecallIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 25,
    viewBox: "0 0 22 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7734 1.50802L18.0084 6.04176C18.1456 6.44997 17.9098 6.8954 17.4819 7.03667L12.6454 8.27943C12.2174 8.42069 11.7593 8.20429 11.6222 7.79607C11.485 7.38786 11.7208 6.94243 12.1487 6.80116L15.1959 6.04176C9.6875 4.28826 4.21483 6.64598 2.25 10.9552C0.225561 15.3952 2.25 20.929 8.04343 23.5309C12.7438 25.4439 18.4846 22.9767 20.625 18.7608L21.5 19.0104C18.9762 24.0667 12.643 26.3575 7.16697 24.1288C1.57399 21.8525 -1.00685 15.7235 1.4025 10.4393C3.81185 5.15516 10.125 3.14966 15.892 4.99313V5.31787L14.2236 2.01957C14.0865 1.61136 14.3222 1.16593 14.7501 1.02466C15.1781 0.883401 15.6362 1.09981 15.7734 1.50802Z",
    fill: "#1A4176"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5696 17.0653C13.2133 17.2077 13.9037 17.2727 14.6237 17.2477C14.9405 17.2367 15.198 17.4281 15.1959 17.6731L15.1826 19.2324C15.1805 19.4774 14.9196 19.6869 14.6028 19.698C9.19415 19.8862 4.83971 16.6485 4.87542 12.4652C4.87751 12.2202 5.13842 12.0107 5.45522 11.9996L7.47123 11.9295C7.78803 11.9184 8.04552 12.1099 8.04343 12.3549C8.03867 12.9118 8.14931 13.4424 8.35817 13.9339C8.4202 14.0877 8.37264 14.263 8.21037 14.3845L6.93476 15.4131C7.75341 16.6495 9.08095 17.6321 10.7056 18.2169L11.9811 17.1927C12.1434 17.0668 12.3684 17.0233 12.5696 17.0653Z",
    fill: "#1A4176"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecallIcon);
export default __webpack_public_path__ + "static/media/recall-icon.a1600e51a746000fc9ef46bb62068582.svg";
export { ForwardRef as ReactComponent };